module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign"
  }, [_c('div', {
    staticClass: "sign_head"
  }, [_vm._v("领用出库")]), _vm._v(" "), (!_vm.isCompleted) ? [_c('div', {
    staticClass: "sign_panel sign_info"
  }, [_c('div', {
    staticClass: "sign_item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.outTitle) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.outCode) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.userName) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel sign_info"
  }, [_c('div', {
    staticClass: "sign_item"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.itemName) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.invNo) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.no) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel",
    staticStyle: {
      "margin-bottom": "1.2rem"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "sign_panel-body"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "qm",
    on: {
      "click": _vm.gotoSign
    }
  }, [(!_vm.url) ? [_c('img', {
    staticClass: "placeholeder",
    attrs: {
      "src": require("../../assets/images/sign/bg-qm.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("点击进入签名")])] : _c('img', {
    staticClass: "signimg",
    attrs: {
      "src": _vm.url,
      "alt": ""
    }
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "sign_bottom"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.gotoSign
    }
  }, [_vm._v("重新签名")]), _vm._v(" "), _c('button', {
    staticClass: "confirm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])])] : _c('div', {
    staticClass: "sign_completed"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/sign/completed.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("完成")])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": require("../../assets/images/sign/icon-lybt.png"),
      "alt": ""
    }
  }), _vm._v("领用标题：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": require("../../assets/images/sign/icon-lydh.png"),
      "alt": ""
    }
  }), _vm._v("领用单号：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": require("../../assets/images/sign/icon-lyrs.png"),
      "alt": ""
    }
  }), _vm._v("领用人：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": require("../../assets/images/sign/icon-pmmc.png"),
      "alt": ""
    }
  }), _vm._v("品目名称：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": require("../../assets/images/sign/icon-kcsl.png"),
      "alt": ""
    }
  }), _vm._v("库存数量：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": require("../../assets/images/sign/icon-lysl.png"),
      "alt": ""
    }
  }), _vm._v("领取数量：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_panel-head"
  }, [_c('div', [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": require("../../assets/images/sign/icon-qm.png"),
      "alt": ""
    }
  }), _vm._v("\n          签名\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sm"
  }, [_c('div', [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": require("../../assets/images/sign/icon-sm.png"),
      "alt": ""
    }
  })]), _vm._v("\n\n          说明：领用出库后，商品由领用人负责，如出现丢失损坏，会按照适当成本赔偿。签字代表同意本说明。\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-666b1304","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/LingYongChuKu.vue
// module id = 541
// module chunks = 2